import { MakoStateType } from '../types/makoStateType';

export const getIsSubuser = (state: MakoStateType): boolean =>
  state.account.type === 'subuser';
